var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRt03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.54 11.3205L13.4345 7.22095L7.30762 13.5274L11.328 17.5483L11.3285 17.5478C11.7362 17.9559 12.2205 18.2794 12.7536 18.5C13.2867 18.7205 13.858 18.8337 14.4349 18.833C16.8636 18.833 18.8331 16.8635 18.8331 14.4348C18.8338 13.8561 18.7199 13.2829 18.498 12.7484C18.276 12.2139 17.9505 11.7286 17.54 11.3205Z",
    fill: "#7AD7B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53783 3.32969C8.72884 2.58131 7.66721 2.16582 6.56514 2.16626C5.39868 2.16626 4.27999 2.62964 3.45518 3.45445C2.63037 4.27926 2.16699 5.39795 2.16699 6.56441C2.16699 7.7121 2.61051 8.75423 3.33088 9.5371L3.3244 9.54358L7.3082 13.5274L13.4351 7.22089L9.53783 3.32969Z",
    fill: "#FFE457"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRt03);
export default __webpack_public_path__ + "static/media/icon_RT03.70266cb7e851d47fcff3d800d95f04a3.svg";
export { ForwardRef as ReactComponent };